@import "@/scss/use-bootstrap-mixins.scss";

.body {
  p.productName {
    margin: 0 0 10px 0;
  }

  img.productImage {
    margin: 0 auto;
    width: 100%;
    max-width: 300px;
    display: block;
  }
}

.footer {
  margin-top: 12px;
}
